import React from 'react'
// import { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// IMAGES
import IMG1 from '../../assets/sp1.png'
import IMG2 from '../../assets/sp2.png'
import IMG3 from '../../assets/sp3.png'
import IMG4 from '../../assets/sp4.png'
import IMG5 from '../../assets/sp5.png'
import IMG6 from '../../assets/sp6.png'

import './header.css'

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

const Header = () => {
  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        // centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide className='shadow'>
          <img src={IMG1} alt="sp1" />
          {/* <div className="overlay">
            <button className='btn btn-primary'>view</button>
            <button className='btn'>buy</button>
          </div> */}
        </SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG2} alt="sp2" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG3} alt="sp3" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG4} alt="sp4" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG5} alt="sp5" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG6} alt="sp6" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG1} alt="sp7" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG2} alt="sp8" /></SwiperSlide>
        <SwiperSlide className='shadow'><img src={IMG3} alt="sp9" /></SwiperSlide>
      </Swiper>
    </>
  )
}

export default Header
